import React, { useMemo } from "react";
import { SubscriptionPreferencesFormButtonComponent } from "../_shared/formButton/SubscriptionPreferencesFormButtonComponent";
import { IState } from "../../../../common/state/IState";
import { umSpPageStateSelector } from "../_shared/selectors";
import { useObjectSelector } from "../../../../common/utils/selectors/useSelectorEx";
import { isSubscriptionFormDataChanged } from "./umSpEditFormButtonsDomain";
import { useDispatch } from "react-redux";
import {
    revertSubscriptionConsentOnSubscriptionPreferencesAction,
    saveSubscriptionConsentOnSubscriptionPreferencesAction,
} from "../subscriptionPreferences/subscriptionPreferencesActions";
import { CheckmarkRoundIconComponent } from "../../../../common/icons/CheckmarkRoundIconComponent";

const i18n = {
    edit: "Save changes",
    saving: "Saving...",
    saved: "Saved!",
    revert: "Revert changes",
};

function selector(s: IState) {
    const { data, oldData, mode } = umSpPageStateSelector(s) ?? {};
    return { data, oldData, mode };
}

export function UmSpEditFormButtonsElement({ el }) {
    const { data, oldData, mode } = useObjectSelector(selector);
    const dispatch = useDispatch();
    const [saveData, revert] = useMemo(
        () => [
            () => {
                dispatch(
                    saveSubscriptionConsentOnSubscriptionPreferencesAction
                );
            },
            () => {
                dispatch(
                    revertSubscriptionConsentOnSubscriptionPreferencesAction
                );
            },
        ],
        []
    );

    const disabled = !isSubscriptionFormDataChanged(oldData, data);

    const title = (
        <>
            {mode == "saved" && <CheckmarkRoundIconComponent />} {i18n[mode]}
        </>
    );
    return (
        <div className={el("buttons")}>
            <SubscriptionPreferencesFormButtonComponent
                title={title}
                className={el("save-btn")}
                onClick={saveData}
                disabled={disabled}
            />

            <SubscriptionPreferencesFormButtonComponent
                title={i18n.revert}
                className={el("revert-btn")}
                onClick={revert}
                disabled={disabled}
            />
        </div>
    );
}
